import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import { CC_PRODUCT_ID, TOKEN_2 } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { getHTMLObject, getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { Divider, Select, Button } from 'antd'
import UMCButton from '../common/UMCButton'
import { DARK_GRAY, PURPLE, } from "../../styles/styleUtils"
import InputField from "./InputField"
import TabExtraContent from '../common/TabExtraContent'
import parse from 'html-react-parser'
import CustomDialog from './CustomDialog'
import getData from './GetData'

//============================
// SIP parameters config page
//============================

// Here is the big problem for page creation, we want to have the same order for each Group/field
// but the JSON does not garantee that the order of object will be respected, nor that the fields 
// in the profiles are always at the same place.
// So we have to define the structure statically.
// Order is :
// 1. SIP trunk
//      1.1 Trunk group name
//      1.2 UTF8 trunk group name
//      1.3 Local number
//      1.4 Number of SIP access
// 2. SIP external gateway
//      2.1 SIP remote domain
//      2.2 SIP outbound proxy
//      2.3 SIP DNS1
//      2.4 SIP DNS2
// 3. SIP outgoing call data
//      3.1 SIP outgoing realm
//      3.2 SIP outgoing username
//      3.3 SIP outgoing password
// 4. SIP registration data
//      4.1 SIP auth domain
//      4.2 SIP external gateway


const SIPParameters = ({onPrevious, onNext, activeProfile, setTrunkConfig}) => {
    const [channels, setChannels] = useState([]); 
    const [configurationData, setConfigurationData] = useState({});
    const [errorsOnPage, setErrorsOnPage] = useState(0);

    const [siptrunkConfig, setSiptrunkConfig] = useImmer({});
    // Dialog parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState();
    // Dialog footer button definition
    const [footer, setFooter] = useState([]);

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);

    let nextStep = false;
    let errorsOnRedraw = errorsOnPage;

    const profileHandler = (data) => {
        setConfigurationData(data[0]);
    }

/*    const getTrunkList = async () => {
        var url, headerSection, response;

        url = SIP_URL + "/siptrunks/" + nodeNumber + "/" + ccproductid;
        headerSection = { headers: {"Authorization": `Bearer ${getSessionItem(TOKEN_2)}`}};
        dispatch(setContentLoading(true));
        response = getData(url, headerSection, trunkListHandler);
        dispatch(setContentLoading(false));
    }*/

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_SIP_TRUNK") + " : " + activeProfile.name));
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        const fetchData = async () => {
            var url, headerSection, response;

            try {
                url = SIP_URL + "/sipprofile/params/" + activeProfile.id;
                headerSection = { headers: {"Authorization": `Bearer ${getSessionItem(TOKEN_2)}`}};

                dispatch(setContentLoading(true));
                response = await getData(url, headerSection, profileHandler);
                dispatch(setContentLoading(false));
                setSiptrunkConfig({});
            }
            catch(e) {
                console.error(e);
                dispatch(setContentLoading(false));
            }
        };
        fetchData();
    }, []);

    // SIP Trunk data handlers
    const comboChange = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Trunk_Data.Number_of_SIP_Acces = value; }); 
    };

    const updateTrunkGroupName = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Trunk_Data.Trunk_Group_Name = value; });
    }

    const updateUTF8TrunkGroupName = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Trunk_Data.UTF8_Trunk_Group_Name = value; });
    }

    const updateLocalNumber = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Trunk_Data.Local_Number = value; });
    }

    // SIP Ext gateway handlers
    const updateSIPRemoteDomain = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Ext_Gateway_Data.SIP_Remote_Domain = value; });
    }

    const updateSIPOutboundProxy = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Ext_Gateway_Data.SIP_Outbound_Proxy = value; });
    }

    const updateSIPDNS1 = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Ext_Gateway_Data.SIP_DNS1_IP_Address = value; });
    }

    const updateSIPDNS2 = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Ext_Gateway_Data.SIP_DNS2_IP_Address = value; });
    }

    // SIP Outgoing handlers
    const updateOutgoingRealm = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Auth_Outgoing_Call_Data.SIP_Outgoing_realm = value; });
    }

    const updateOutgoingUsername = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Auth_Outgoing_Call_Data.SIP_Outgoing_Username = value; });
        //setTrunkConfig(siptrunkConfig);
    }

    const updateOutgoingPassword = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Auth_Outgoing_Call_Data.SIP_Outgoing_Password = value; });
    }

    // SIP Registration handlers
    const updateAuthenticationDomain = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Registration_Data.SIP_Authentification_Domain = value; });
    }

    const updateRegistrationID = (value) => {
        setSiptrunkConfig(draft => { draft.Profile.UI_SIP_Registration_Data.SIP_Enrg_Extgw_Id = value; });
    }

    // Error handler (count errors on the page)
    const errorHandler = (value) => {

        if (value === true) {
            errorsOnRedraw++;
        }
        else {
            if (errorsOnPage > 0)
                errorsOnRedraw--;
        }
        setErrorsOnPage(errorsOnRedraw);
    }

    // Create JSON config for SIPtrunk
    function createTrunkConfig() {
        let obj =  { Profile : {} };
        Object.keys(configurationData.Profile).forEach(group => {
            obj.Profile[group] = { };
            Object.keys(configurationData.Profile[group]).forEach(key => {
                obj.Profile[group][key] = configurationData.Profile[group][key].defaultValue;
            })
        });

        return obj;
    }

    // Create the list of values to display in the combobox
    function comboValues() {
        var comboList = []; 

        configurationData.Profile.UI_SIP_Trunk_Data.Number_of_SIP_Acces.values.map(item => { 
            comboList.push({"value": item, "label": String(item/2) + " * 62 = " + item/2*62});
        });
        return comboList;
    }

    // async function to get the data
    async function getRequest(url, headerSection) {
        const response = await fetch(url, headerSection);

        if (response.ok) {
            return await response.json();
        }
        else if (response.status === 401) {
            window.location = "/logout"
        }
        return {};
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);

        // Change page
        if (nextStep) 
            onNext();
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        nextStep = false; // Avoid to continue if cancel has been hit  
    };

    // Buttons for modal footer
    const yesno = [
        <Button key="cancel" type="primary" onClick={handleCancel} className="sip-modal-btn sip-navigation-back">
            {getTranslated(dict, "LABEL_NO")}
        </Button>,
        <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
            {getTranslated(dict, "LABEL_YES")} 
        </Button>,
      ];
      
    // Validation handler for the page
    // 1. Prefix entered by the user is empty --> Case 1
    // 2. prefix entered by the user is not empty
    //     1. prefix exists is OXE
    //         a. prefix is ARS
    //             i.	no trunk is existing  --> Case 2
    //             ii.	trunk is existing     --> Case 3
    //         b. prefix is not ARS           --> Case 4
    //     2. prefix does not exist in OXE
    //         a. no existing trunk           --> Case 5
    //         b. trunk is existing           --> Case 6
    async function validateFields() {
        var ccproductid = getSessionItem(CC_PRODUCT_ID);
        var nodeNumber = oxeAndClientInfo?.nodeNumber || "";
        var url, headerSection, json;
        
        if (siptrunkConfig?.Profile?.UI_SIP_Trunk_Data?.Local_Number) {
            // Validate prefix against OXE configuration
            try {
                console.log("prefix content: ", siptrunkConfig.Profile.UI_SIP_Trunk_Data.Local_Number);
                url = SIP_URL + "/checkprefixandtrunk/" + nodeNumber + "/" + ccproductid + "/" + siptrunkConfig.Profile.UI_SIP_Trunk_Data.Local_Number;
                headerSection = { headers: {"Authorization": `Bearer ${getSessionItem(TOKEN_2)}`}};
                json = await getRequest(url, headerSection);
                if (json) {
                    // The following part of code (case 1) will no longer be used as the prefix must be filled 24/01/2025
                    if (siptrunkConfig.Profile.UI_SIP_Trunk_Data.Local_Number === "")   // Case 1
                    {
                        setDlgType("Bubble");
                        setTitle("");
                        setMessage(parse(getTranslated(dict, "MSG_PREFIX_CASE1") + "<br/><br/>" + getTranslated(dict, "MSG_Q_CONTINUE")));
                        setFooter(yesno);
                        nextStep = true;
                        console.log("Case 1");
                    }
                    else
                    if (json.data[0].isPrefixExisting === true) {
                        if (json.data[0].isARSPrefix === true) {
                            if (json.data[0].isTrunkExisting === false) {   // Case 2
                                setDlgType("Bubble");
                                setTitle("");
                                setMessage(parse(getTranslated(dict, "MSG_PREFIX_CASE2") + "<br/><br/>" + getTranslated(dict, "MSG_Q_CONTINUE")));
                                setFooter(yesno);
                                nextStep = true;
                                console.log("Case 2");
                            }
                            else {  // Case 3
                                setDlgType("Bubble");
                                setTitle("");
                                setMessage(parse(getTranslated(dict, "MSG_PREFIX_CASE3") + "<br/><br/>" + getTranslated(dict, "MSG_Q_CONTINUE")));
                                setFooter(yesno);
                                nextStep = true;
                                console.log("Case 3");
                            }
                        }
                        else {  // Case 4
                            setDlgType("Error");
                            setTitle(getTranslated(dict, "LABEL_SIP_TRUNK_CREATION_IMPOSSIBLE"));
                            setMessage(getTranslated(dict, "MSG_PREFIX_CASE4"));
                            setFooter([
                                <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
                                    {getTranslated(dict, "LABEL_OK")} 
                                </Button>,
                            ]);
                            console.log("Case 4");
                        }
                    }
                    else {
                        if (json.data[0].isTrunkExisting === false) {   //case 5
                            setDlgType("Bubble");
                            setTitle("");
                            setMessage(parse(getTranslated(dict, "MSG_PREFIX_CASE5") + "<br/><br/>" + getTranslated(dict, "MSG_Q_CONTINUE")));
                            setFooter(yesno);
                            nextStep = true;
                            console.log("Case 5");
                        }
                        else {  // Case 6
                            setDlgType("Bubble");
                            setTitle("");
                            setMessage(parse(getTranslated(dict, "MSG_PREFIX_CASE6") + "<br/><br/>" + getTranslated(dict, "MSG_Q_CONTINUE")));
                            setFooter(yesno);
                            nextStep = true;
                            console.log("Case 6");
                        }
                    }
                    showModal();
                }
                else {
                    console.log("JSON Error");
                    // TODO: JSON error
                }
            }
            catch(e) {
                console.error(e);
            }
        }
        else
            onNext();

        // Update the parent state
        setTrunkConfig(siptrunkConfig);
    }

    // Top right icons 
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={activeProfile.docRef ? ["document", "help"] : ["help"]}
            documentButtonText={activeProfile.docRef}
            handleDocument={() => {
                if (activeProfile.docUrl !== "")
                    window.open(`${activeProfile.docUrl}`, "_blank")
               }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-trunk__SIP-Parameters`, "_blank")
           }}
        />
    }

    if (configurationData?.Profile !== undefined && siptrunkConfig?.Profile === undefined) {
        setSiptrunkConfig(createTrunkConfig());
        setChannels(comboValues());
    }

    return (<>
        { (() => { 
            if (configurationData?.Profile?.UI_SIP_Trunk_Data !== undefined) {
            return (<div>
                <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{borderColor: DARK_GRAY,}}>
                    {getTranslated(dict, "LABEL_UI_SIP_TRUNK_DATA")}
                </Divider>

                { // Trunk group name
                configurationData?.Profile?.UI_SIP_Trunk_Data?.Trunk_Group_Name &&
                <InputField label={getTranslated(dict, "PARAM_TRUNK_GROUP_NAME")} 
                    defaultValue={configurationData?.Profile?.UI_SIP_Trunk_Data?.Trunk_Group_Name?.defaultValue} 
                    regexp={configurationData?.Profile?.UI_SIP_Trunk_Data?.Trunk_Group_Name?.pattern} 
                    handleChange={updateTrunkGroupName}
                    handleError={errorHandler} />
                }

                { // UTF-8 Trunk group name
                configurationData?.Profile?.UI_SIP_Trunk_Data?.UTF8_Trunk_Group_Name &&
                <InputField label={getTranslated(dict, "PARAM_UTF_TRUNK_GROUP_NAME")}
                    defaultValue={configurationData?.Profile?.UI_SIP_Trunk_Data?.UTF8_Trunk_Group_Name?.defaultValue}
                    regexp={configurationData.Profile?.UI_SIP_Trunk_Data?.UTF8_Trunk_Group_Name?.pattern}
                    handleChange={updateUTF8TrunkGroupName}
                    handleError={errorHandler} />
                }

                { // Prefix Number
                configurationData?.Profile?.UI_SIP_Trunk_Data?.Local_Number &&
                <InputField label={getTranslated(dict, "PARAM_PREFIX_NUMBER")}
                    defaultValue={configurationData.Profile?.UI_SIP_Trunk_Data?.Local_Number?.defaultValue}
                    regexp={configurationData.Profile?.UI_SIP_Trunk_Data?.Local_Number?.pattern}
                    handleChange={updateLocalNumber}
                    handleError={errorHandler} />
                }

                { // Number of SIP accesses
                configurationData?.Profile?.UI_SIP_Trunk_Data?.Number_of_SIP_Acces &&
                <div className="field-wrap">
                    <div className="sip-textfield-label">{getTranslated(dict, "PARAM_NB_SIP_ACCESSES")}</div>
                        <Select
                        defaultValue={(configurationData.Profile?.UI_SIP_Trunk_Data?.Number_of_SIP_Acces?.defaultValue/2).toString() + " * 62 = " + configurationData.Profile?.UI_SIP_Trunk_Data?.Number_of_SIP_Acces?.defaultValue/2*62}
                        style={{  width: '100%',}}
                        onChange={comboChange}
                        options={channels}
                        />
                </div>
                }
            </div>)}})()
        }
        { (() => { 
            if (configurationData?.Profile?.UI_SIP_Ext_Gateway_Data !== undefined) {
            return (<div>
                <Divider orientation="left" orientationMargin="0" plain style={{borderColor: DARK_GRAY,}}>
                    {getTranslated(dict, "LABEL_UI_SIP_EXT_GATEWAY_DATA")}
                </Divider>

                { // SIP Remote Domain
                configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_Remote_Domain &&
                <InputField label={getTranslated(dict, "PARAM_SIP_REMOTE_DOMAIN")} 
                    defaultValue={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_Remote_Domain?.defaultValue} 
                    regexp={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_Remote_Domain?.pattern} 
                    handleChange={updateSIPRemoteDomain} 
                    handleError={errorHandler}
                    validationPattern="Domain" />
                }

                { // SIP Outbound Proxy
                configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_Outbound_Proxy &&
                <InputField label={getTranslated(dict, "PARAM_SIP_OUTBOUND_PROXY")}
                    defaultValue={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_Outbound_Proxy?.defaultValue}
                    regexp={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_Outbound_Proxy?.pattern}
                    handleChange={updateSIPOutboundProxy}
                    handleError={errorHandler} />
                }

                { // SIP DNS1 IP Address
                configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_DNS1_IP_Address &&
                <InputField label={getTranslated(dict, "PARAM_SIP_DNS1")}
                    defaultValue={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_DNS1_IP_Address?.defaultValue}
                    regexp={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_DNS1_IP_Address?.pattern}
                    handleChange={updateSIPDNS1} 
                    handleError={errorHandler}
                    validationPattern="IPv4" />
                }

                { // SIP DNS2 IP Address
                configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_DNS2_IP_Address &&
                <InputField label={getTranslated(dict, "PARAM_SIP_DNS2")}
                    defaultValue={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_DNS2_IP_Address?.defaultValue}
                    regexp={configurationData.Profile?.UI_SIP_Ext_Gateway_Data?.SIP_DNS2_IP_Address?.pattern}
                    handleChange={updateSIPDNS2} 
                    handleError={errorHandler}
                    validationPattern="IPv4" />
                }
            </div>)}})()
        }
        { (() => { 
            if (configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data !== undefined) {
            return (<>
                <div className="profile-span">
                    <Divider orientation="left" orientationMargin="0" plain style={{borderColor: DARK_GRAY,}}>
                        {getHTMLObject(dict, "LABEL_UI_SIP_AUTH_OUT_CALL_DATA")}
                    </Divider>
                </div>
                <div>
                    { // Outgoing realm
                    configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_realm &&
                    <InputField label={getTranslated(dict, "PARAM_OUTGOING_REALM")}
                        defaultValue={configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_realm?.defaultValue}
                        regexp={configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_realm?.pattern}
                        handleChange={updateOutgoingRealm}
                        handleError={errorHandler} />
                    }

                    { // Outgoing username
                    configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_Username &&
                    <InputField label={getTranslated(dict, "PARAM_OUTGOING_USERNAME")}
                        defaultValue={configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_Username?.defaultValue}
                        regexp={configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_Username?.pattern}
                        handleChange={updateOutgoingUsername}
                        handleError={errorHandler} />
                    }

                    { // Outgoing password
                    configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_Password &&
                    <InputField label={getTranslated(dict, "PARAM_OUTGOING_PASSWORD")}
                        defaultValue={configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_Password?.defaultValue}
                        regexp={configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_Password?.pattern}
                        handleChange={updateOutgoingPassword}
                        handleError={errorHandler} 
                        contentDisplay={configurationData?.Profile?.UI_SIP_Auth_Outgoing_Call_Data?.SIP_Outgoing_Password?.echo} />
                    }
                </div>
                <div>
                    <Divider orientation="left" orientationMargin="0" style={{ 'color': PURPLE, 'font-weight': 'bold', 'margin': '5px 0px'}}>
                        {getTranslated(dict, "LABEL_UI_SIP_REGISTRATION_DATA")}
                    </Divider>

                    { // Belonging domain
                    configurationData?.Profile?.UI_SIP_Registration_Data?.SIP_Authentification_Domain &&
                    <InputField label={getTranslated(dict, "PARAM_AUTH_DOMAIN")}
                        defaultValue={configurationData?.Profile?.UI_SIP_Registration_Data?.SIP_Authentification_Domain?.defaultValue}
                        regexp={configurationData?.Profile?.UI_SIP_Registration_Data?.SIP_Authentification_Domain?.pattern}
                        handleChange={updateAuthenticationDomain}
                        handleError={errorHandler} />
                    }

                    { // Registration ID
                    configurationData?.Profile?.UI_SIP_Registration_Data?.SIP_Enrg_Extgw_Id &&
                    <InputField label={getTranslated(dict, "PARAM_REGISTRATION_EXTGW_ID")}
                        defaultValue={configurationData?.Profile?.UI_SIP_Registration_Data?.SIP_Enrg_Extgw_Id?.defaultValue}
                        regexp={configurationData?.Profile?.UI_SIP_Registration_Data?.SIP_Enrg_Extgw_Id?.pattern}
                        handleChange={updateRegistrationID}
                        handleError={errorHandler} />
                    }
                </div>
            </>)}})()
        }
        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onPrevious}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_CREATE")}
                type="primary"
                onClick={validateFields}
                disabled={errorsOnPage !== 0} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "500px"}
            footer={footer}
            type={dlgType} 
            onCancel={handleCancel}
            >
            {message}
        </CustomDialog>
    </>);
}

export default SIPParameters;